import React from 'react';
import { Link } from 'react-router-dom';
import { FiCheckCircle, FiArrowRight } from 'react-icons/fi';
import siteData from '../data/siteData';
import ScrollReveal from './ScrollReveal';

export default function AboutUs() {
  const { heading, paragraphs } = siteData.homepage_sections.about_us;

  const highlights = [
    '30+ years of combined professional experience',
    'Young and Dynamic Chartered Accountants team',
    'Serving diverse industries across India',
    'Expert in GST, Income Tax, Company Law & Audit',
    'Commodity Exchange inspection – NCDEX, MCX',
  ];

  return (
    <section className="about-section" style={{ paddingTop: '20px' }}>
      <div className="container about-grid">
        {/* Content side */}
        <div className="about-content" style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto' }}>
          <ScrollReveal>
            <span className="section-badge">Who We Are</span>
            <h2 className="section-title">{heading}</h2>
            <div className="gold-divider" style={{ margin: '16px auto', width: '60px' }} />
          </ScrollReveal>

          <ScrollReveal delay={150}>
            {paragraphs.map((p, i) => (
              <p key={i} className="about-para">{p}</p>
            ))}
          </ScrollReveal>

          <ScrollReveal delay={250}>
            <ul className="about-highlights" style={{ display: 'inline-flex', flexDirection: 'column', textAlign: 'left', margin: '24px auto', gap: '12px' }}>
              {highlights.map((h) => (
                <li key={h} className="about-highlight-item">
                  <FiCheckCircle className="about-check-icon" size={18} />
                  <span>{h}</span>
                </li>
              ))}
            </ul>
          </ScrollReveal>

          <ScrollReveal delay={350}>
            <Link to="/contact" className="btn-primary">
              Work With Us <FiArrowRight />
            </Link>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
